import { CustomerSessionResponse } from 'services/api/responses/responseTypes';
import type { ICustomerSession } from './iCustomerSession';

export default class CustomerSession implements ICustomerSession {
  id: string;

  returnUrl: string;

  url: string;

  constructor(data: CustomerSessionResponse) {
    this.id = data.id;
    this.returnUrl = data.return_url;
    this.url = data.url;
  }
}
